











































import Vue from 'vue'
import Component from 'vue-class-component'
import { getModule } from 'vuex-module-decorators'
import Card from '@/components/Card.vue'
import BarChart from '@/components/chart/BarChart.vue'
import { IBarChartData } from '@/interfaces'
import LoaderWrapper from '@/components/layout/LoaderWrapper.vue'
import { BillingModule } from '@/store/modules/billing.module'
import Icon from '@/components/Icon.vue'

const moment = require('moment')

@Component({
  components: {
    Card,
    Icon,
    BarChart,
    LoaderWrapper
  }
})
export default class ChainsStatistics extends Vue {
  billingInstanceModule: BillingModule = getModule(BillingModule, this.$store);
  isLoading: boolean = false;
  params = {
    months: 5,
    skip: 0
  };
  data: Array<{ data: IBarChartData[], date: Date }>= [];

  get statistics () {
    return this.$store.state.billing.chainsStatistics || []
  }

  async mounted () {
    this.fetchStatistics()
  }

  slideTo (skip: number) {
    this.params.skip += skip
    this.fetchStatistics()
  }

  isPrevAvailable () {
    return this.data.length === 5
  }

  isNextAvailable () {
    return this.params.skip !== 0
  }

  async fetchStatistics () {
    this.isLoading = true
    await this.billingInstanceModule.fetchChainsStatistics(this.params)
    this.initStatistics()
    this.isLoading = false
  }
  initStatistics () {
    const maxTotal = Math.max(...this.statistics.map((item: any) => item.lost + item.current))
    this.data = this.statistics.map((item: any) => {
      const date = item.date
      return {
        total: maxTotal,
        data: [{
          items: [{
            value: item.lost,
            color: '#FF6633',
            label: 'Lost'
          },
          {
            value: item.gained,
            color: '#FFDFBF',
            label: 'Gained'
          },
          {
            value: item.current - item.gained,
            color: '#EBE5F8',
            label: 'Current'
          }]
        }],
        date
      }
    })
  }
}
